import { Controller } from "@hotwired/stimulus"

/**
 * Plant search / filter forms (catalog + planner):
 * - Submits form on filter changes
 * - When user types in search (catalog), resets other filters
 * - Catalog: beforeSubmit clears stale search param from URL when field emptied
 */
export default class extends Controller {
  static override targets = [
    "search",
    "zone",
    "region",
    "layer",
    "utility",
    "soilTexture",
    "edibleOnly",
  ]

  declare readonly hasSearchTarget: boolean
  declare readonly searchTarget: HTMLInputElement
  declare readonly hasZoneTarget: boolean
  declare readonly zoneTarget: HTMLSelectElement
  declare readonly hasRegionTarget: boolean
  declare readonly regionTarget: HTMLSelectElement
  declare readonly hasLayerTarget: boolean
  declare readonly layerTarget: HTMLSelectElement
  declare readonly hasUtilityTarget: boolean
  declare readonly utilityTarget: HTMLSelectElement
  declare readonly hasSoilTextureTarget: boolean
  declare readonly soilTextureTarget: HTMLSelectElement
  declare readonly hasEdibleOnlyTarget: boolean
  declare readonly edibleOnlyTarget: HTMLInputElement

  submitForm(): void {
    ;(this.element as HTMLFormElement).requestSubmit()
  }

  searchChanged(): void {
    if (!this.hasSearchTarget) return

    const searchValue = this.searchTarget.value.trim()

    if (searchValue.length > 0) {
      if (this.hasZoneTarget) this.zoneTarget.value = ""
      if (this.hasRegionTarget) this.regionTarget.value = ""
      if (this.hasLayerTarget) this.layerTarget.value = ""
      if (this.hasUtilityTarget) this.utilityTarget.value = ""
      if (this.hasSoilTextureTarget) this.soilTextureTarget.value = "any"
      if (this.hasEdibleOnlyTarget) this.edibleOnlyTarget.checked = false
    }
  }

  beforeSubmit(event: Event): void {
    if (!this.hasSearchTarget) return

    const searchValue = this.searchTarget.value.trim()

    if (searchValue === "" && this.hasSearchParam()) {
      event.preventDefault()
      this.searchTarget.value = ""
      ;(this.element as HTMLFormElement).requestSubmit()
    }
  }

  private hasSearchParam(): boolean {
    const params = new URLSearchParams(window.location.search)
    return params.has("search") && params.get("search") !== ""
  }
}
